<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><i>To Omahans, living and dead, who have preserved our city’s history and their family histories.</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?861be4e2